import { useRef } from "react";
import type { CSSProperties, MouseEvent, ReactNode } from "react";
import { cx } from "@/lib/cx";

interface TiltProps {
  children: ReactNode;
  max?: number;
  scale?: number;
  className?: string;
  style?: CSSProperties;
}

export default function Tilt({ children, max = 6, scale = 1.01, className, style }: TiltProps): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);

  function onMove(e: MouseEvent<HTMLDivElement>): void {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width;
    const y = (e.clientY - r.top) / r.height;
    const rx = (0.5 - y) * max;
    const ry = (x - 0.5) * max;
    el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg) scale(${scale})`;
    el.style.setProperty("--tilt-x", `${x * 100}%`);
    el.style.setProperty("--tilt-y", `${y * 100}%`);
  }

  function onLeave(): void {
    const el = ref.current;
    if (!el) return;
    el.style.transform = "";
  }

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={cx("tilt", className)}
      style={{ transition: "transform 0.18s ease-out", willChange: "transform", ...style }}
    >
      {children}
    </div>
  );
}
